export const faqs = [
  {
    question: "How much area is required to install a rooftop solar system?",
    answer:
      "The required area for rooftop solar installation depends on the system capacity. On average, 1 kW of solar panels needs around 100 sq. ft. of shadow-free rooftop space. A 10 kW system would require approximately 1,000 sq. ft.",
  },
  {
    question: "How much does a solar rooftop cost in India?",
    answer:
      "The cost of a solar rooftop system in India ranges from ₹40,000 to ₹60,000 per kW for residential installations. Prices vary based on system size, technology, and government subsidies.",
  },
  {
    question: "How to install a solar roof?",
    answer:
      "Install solar rooftop system by using below steps:\n\nSite Assessment - Evaluating space, sunlight availability, and load capacity\n\nSystem Design & Financial Planning - Customizing the setup based on energy needs\n\nApprovals & Permits - Obtaining necessary government approvals (if applicable)\n\nInstallation - Mounting panels, inverters, and electrical connections\n\nTesting & Commissioning - Ensuring optimal performance and grid integration",
  },
  {
    question: "How long does it take to install rooftop solar for a commercial property?",
    answer:
      "For a commercial rooftop solar system, installation typically takes 4 to 8 weeks, depending on system size, approvals, and site conditions. Smaller projects may be completed in 2 to 4 weeks.",
  },
  {
    question: "Can your rooftop solar solution work in all weather conditions?",
    answer:
      "Yes! GSE's rooftop solar solutions are designed to be used in all weather conditions, including cloudy and rainy days. Advanced technologies like high-efficiency panels, smart inverters, and robotic cleaning ensure consistent power generation and long-term durability.",
  },
  {
    question: "Do I need to clean my Solar plant?",
    answer:
      "It is a good practice to clean the solar panels 1-2 times a month. It is safer to clean the panels early in the morning or at night when no incident sun rays are present and the power plant is not producing any electricity. You can simply use a clean wet cloth, soft nylon brush or sponge to wipe the surface but ensure the panels are clear of any moisture. Don't use metal brushes or detergents as these may streak the glass of the panel.",
  },
  {
    question: "Can Solar projects damage my roof?",
    answer:
      "SolarSquare Energy has a UL certification (one of the highest quality and safety standards in the world) and ensures that no damage to the existing structures takes place during the installation or running of the solar plant. We use a multitude of techniques like non-penetrating structures and waterproofing solutions to ensure your roof's integrity.",
  },
  {
    question: "Do Solar Rooftop projects have a high maintenance cost?",
    answer:
      "A Solar Rooftop module comprises minimal moving parts and hence has very low maintenance cost. SolarSquare Energy provides first 5-year maintenance free of cost to clients ensuring a hassle-free experience for all our customers.",
  },
  {
    question: "What is the life of a rooftop solar system?",
    answer:
      "The Solar Plant life is 25 years. The main components are solar panels and inverters. Solar panels have a warranty of 25 years and inverter warranty ranges from 5-12 years.",
  },
  {
    question: "Are there any subsidies provided by the government for solar projects?",
    answer:
      "There are no subsidies available for commercial entities. For residential rooftop solar projects, subsidies are released by state governments intermittently. Whenever subsidy is applicable, SolarSquare Energy provides it upfront to the customer in the project cost itself. At present, the Madhya Pradesh government has released a lucrative solar subsidy for the residential sector.",
  },
];
